import React from 'react'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import { useOutletContext } from 'react-router-dom'
import SectionHeadline from '../../../../@Common/SectionHeadline/SectionHeadline'
import ClientBackChannelLogoutField from '../../../../Sessions/ClientBackChannelLogoutField'

// This section will grow to hold this listing's full OpenID Connect configuration; back-channel
// logout is the first setting.
export function OpenIdConnectSection() {
  const { verificationListing } = useOutletContext()

  return (
    <div>
      <Grid container direction="column">
        <Grid item>
          <SectionHeadline className="mb-2">Back-channel Logout</SectionHeadline>
          <Typography className="text-sm text-gray-medium mb-4">
            The URL the identity provider calls to sign this application out when a member&apos;s
            session is revoked.
          </Typography>
          <ClientBackChannelLogoutField clientId={verificationListing.clientId} />
        </Grid>
      </Grid>
    </div>
  )
}

export default OpenIdConnectSection
